import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/admin/account-management": [4],
		"/admin/cost-tracker": [5],
		"/admin/diagnostic-testing": [6,[2]],
		"/admin/diagnostic-testing/new": [8,[2]],
		"/admin/diagnostic-testing/[id]": [7,[2]],
		"/admin/event-codes": [9],
		"/admin/soundtrack-capacity": [10],
		"/admin/venue-rentals": [11],
		"/cookies": [12],
		"/email-verified": [13],
		"/guest/events/[id]": [14],
		"/guest/trivia-admission/[publicId]": [15],
		"/guest/trivia-rsvp/[publicId]": [16],
		"/guest/venue/[id]": [17],
		"/host": [18],
		"/host/account": [19],
		"/host/events": [20],
		"/host/events/[id]": [21],
		"/host/events/[id]/copy": [22],
		"/host/events/[id]/memoir": [23],
		"/host/events/[id]/reschedule": [24],
		"/host/rental/scheduling": [25],
		"/host/scheduling": [26],
		"/host/signup": [27],
		"/host/trivia": [28],
		"/host/trivia/scheduling": [32],
		"/host/trivia/[id]": [29],
		"/host/trivia/[id]/reschedule": [30],
		"/host/trivia/[id]/rsvp": [31],
		"/host/venue": [33],
		"/host/venue/scenes": [34],
		"/host/verify": [35],
		"/login": [36],
		"/password-reset": [37],
		"/privacy-policy": [38],
		"/signup": [39],
		"/signup/owner": [40],
		"/signup/renter": [41],
		"/start": [42],
		"/terms-of-use": [43]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';